import { render, staticRenderFns } from "./WagonAdditionalGrid.vue?vue&type=template&id=65af8ef8&scoped=true"
import script from "./WagonAdditionalGrid.vue?vue&type=script&lang=js"
export * from "./WagonAdditionalGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65af8ef8",
  null
  
)

export default component.exports